import { useEffect, useMemo, useState } from 'react';
import { Form, FormItemProps } from 'antd';
import { connect } from 'react-redux';

import { DefaultOptionType, SelectProps } from 'antd/es/select';
import { Select } from 'antd/lib';
import { useUser } from '../../../store/user';
import { userById as userByIdAction, userByIdClear as userByIdClearAction } from '../../../store/user/byId';
import { userList as userListAction, userListClear as userListClearAction } from '../../../store/user/list';
import displayUserName from '../../../utils/userName';

interface SelectUserProps {
  userList: typeof userListAction;
  userListClear: typeof userListClearAction;
  userById: typeof userByIdAction;
  userByIdClear: typeof userByIdClearAction;
  defaultUserId?: string;

  formItemProps?: FormItemProps;
  selectProps?: SelectProps<string, DefaultOptionType>;
}

function SelectUser({
  userList,
  userListClear,
  userById,
  userByIdClear,
  defaultUserId,
  formItemProps: { label = 'User', ...formItemProps } = {},
  selectProps,
}: SelectUserProps) {
  const { list, byId } = useUser();
  const [search, setSearch] = useState('');

  const options: DefaultOptionType[] = useMemo(() => {
    // eslint-disable-next-line max-len
    const optionsFromList: DefaultOptionType[] = list.response?.data.map((user): DefaultOptionType => ({ label: displayUserName(user, true), value: user.id }))
      || [];

    if (!search && defaultUserId && byId.response && !list.response?.data.some(({ id }) => id === defaultUserId)) {
      optionsFromList.unshift({ label: displayUserName(byId.response), value: byId.response.id });
    }

    return optionsFromList;
  }, [list.response?.data, byId.response]);

  useEffect(() => {
    if (
      defaultUserId
      && list.response?.data
      && !byId.response
      && !list.response.data.some(({ id }) => id === defaultUserId)
    ) {
      userById({ id: defaultUserId });
    }
  }, [list.response?.data, defaultUserId]);

  useEffect(
    () => () => {
      userListClear();
      userByIdClear();
    },
    [],
  );

  useEffect(() => {
    userList({ page: 1, pageSize: 100, search, roles: ['user', 'worker', 'business_owner', 'admin', 'root'] });
  }, [search]);

  return (
    <Form.Item label={label} name="userId" {...formItemProps}>
      <Select
        placeholder={label}
        onSearch={setSearch}
        showSearch
        allowClear
        loading={list.loading || byId.loading}
        style={{ width: '100%' }}
        {...selectProps}
        // optionFilterProp="label" // Ads additional filter by label, and do not shows users which match by email
        filterOption={false}
        options={options}
      />
    </Form.Item>
  );
}

export default connect(undefined, {
  userList: userListAction,
  userListClear: userListClearAction,
  userById: userByIdAction,
  userByIdClear: userByIdClearAction,
})(SelectUser);
